import * as Constants from 'constants/product-tab';

interface SelectedProductTabAction {
  type: typeof Constants.SELECTED_PRODUCT_TAB;
  selectedProductTab: unknown;
}

interface BuyProductAction {
  type: typeof Constants.BUY_PRODUCT;
  // `product` is an opaque domain payload at this boundary; `null` when hiding the modal.
  product: unknown;
}

export function selectedProductTab(value: unknown): SelectedProductTabAction {
  return { type: Constants.SELECTED_PRODUCT_TAB, selectedProductTab: value };
}

export function showBuyModal(product: unknown): BuyProductAction {
  return { type: Constants.BUY_PRODUCT, product };
}

export function hideBuyModal(): BuyProductAction {
  return { type: Constants.BUY_PRODUCT, product: null };
}
